import React, { useState } from 'react'
import './manage.css'
// import '../counter.css'

import Machinecard from '../../../../assets/Help/machineCard.avif'
import AddMachine from '../../../../assets/Help/addMachine.webp'
import Aisle from '../../../../assets/Help/aisle.avif'
import EditProduct from '../../../../assets/Help/editProduct.webp'
import Filter from '../../../../assets/Help/filter.webp'
import MachineDetails from '../../../../assets/Help/machineDetails.webp'
import Franchise from '../../../../assets/Help/Franchise.webp'
import Products from '../../../../assets/Help/Products.webp'
import Categories from '../../../../assets/Help/Categories.webp'
import AddProducts from '../../../../assets/Help/addProduct_Wrap.webp'
import Add from '../../../../assets/Help/Add.avif'
import Draft from '../../../../assets/Help/draft.webp'
import NewAddv from '../../../../assets/Help/newAddv.webp'
import CustomerTypes from '../../../../assets/Help/customerTypes.webp'
import CustomersTable from '../../../../assets/Help/customersTable.webp'
import ViewCustomer from '../../../../assets/Help/viewCustomer_member.webp'
import NewCustomer from '../../../../assets/Help/newCustomer.webp'
import offerPage from '../../../../assets/Help/offerPage.webp'
import DiscountOffer_popup from '../../../../assets/Help/discountOffer_popup.webp'
import NewDiscountofferpage from '../../../../assets/Help/newDiscountofferpage.webp'
import CouponTableView from '../../../../assets/Help/couponTableView.webp'
import ViewCoupon from '../../../../assets/Help/viewCoupon.webp'
import NewCoupons from '../../../../assets/Help/newCoupons-popUp.webp'
import UsersListRoles from '../../../../assets/Help/usersListRoles.webp'
import NewUserForm from '../../../../assets/Help/newUserForm.webp'
import { Box, Divider, } from '@mui/material'
import { useThemeContext } from '../../../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS } from '../../../../Utils/constants.js';
import { useTranslation } from 'react-i18next';
// import { DotFilledIcon } from '@radix-ui/react-icons'

const Manage = () => {
    const { mode } = useThemeContext();
    const { t } = useTranslation();
    const containerBG = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
    const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const headingcolor2 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;

    return (

        <div className='manage-container counter-reset-section'>

            <Box classNames="counter-section">
                <Box className='navigation-ol-list'>

                    <Box className="counter-reset-section " sx={{ width: "100%" }}>
                        <h1 className='home-title'> {t('help.manageTitle')}</h1>
                        <p style={{
                            color: subtitletext,
                            marginBottom: '20px'
                        }} className='home-subtitle'> {t('help.managesubTitle')}</p>
                        <li style={{ width: "100%" }} className='home-keyFeature-text counter-b'>1. {t('help.vendingMachines')}
                        </li>
                    </Box>

                </Box>
                <Divider style={{ marginBottom: '40px', marginTop: '20px' }} />

                {/* 1.1 */}
                <Box className="manage-list-Box">
                    {/* <ol style={{ paddingLeft: "0px" }}> */}
                    <li style={{ width: "100%" }} className=' number-structure counter-b'>1.1 {t('help.internalMachines')}
                    </li>
                    <Box className='number-sec-container'>

                        <Box sx={{ marginTop: '10px' }} className="list-container manage-list-container">
                            <Box className='list-numbers'>
                                <ol style={{ paddingLeft: "0px" }}>
                                    <li style={{
                                    }} className='number-structure counter-c' >1.1.1 {t('help.listing')}

                                    </li>
                                </ol>
                            </Box>

                            <Box className='manage-discription level_3'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.listingpoint1')}</p>
                                <Box>

                                    <p style={{
                                        color: subtitletext
                                    }} className='home-Navi-bar-text'>
                                        {t('help.listingpoint2')}</p>
                                    <ul className='description-list' >


                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk'>{t('help.listingpoint3')}</li>
                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk'> {t('help.listingpoint4')}</li>


                                    </ul>
                                </Box>
                                <Box>
                                    <p style={{
                                        color: subtitletext
                                    }} className='home-Navi-bar-text' >
                                        {t('help.listingpoint5')}</p>
                                    <ul className='description-list'>
                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk'>{t('help.listingpointred')}</li>
                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk'>{t('help.listingpointyellow')}</li>
                                    </ul>
                                </Box>
                                <p style={{
                                    color: subtitletext
                                }} className='home-Navi-bar-text'>{t('help.listingpoint6')}</p>
                                <p style={{
                                    color: subtitletext
                                }} className='home-Navi-bar-text'>{t('help.listingpoint7')}</p>



                            </Box>
                        </Box>
                        <Box className='nav-svg-sec'>
                            <img style={{
                                width: '90%',
                                // maxHeight: '500px',
                                // marginTop: '12px',
                            }} src={Machinecard} alt="Machine Card" />

                        </Box>
                    </Box>

                    <Divider className='divider view-divider manage-divider ' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='number-sec-container'>

                        <Box className="list-container manage-list-container">

                            <Box className='list-numbers'>
                                <ol style={{ paddingLeft: "0px" }}>

                                    <li style={{
                                        listStyle: 'none',
                                        marginLeft: '-7px'
                                    }} className='number-structure counter-c' >1.1.2 {t('help.machineTab')}</li>
                                </ol>
                            </Box>
                            <Box className='manage-discription level_3'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.machinepoint1')}</p>
                                <Box>

                                    <p style={{
                                        color: subtitletext
                                    }} className='home-Navi-bar-text'>
                                        {t('help.machinepoint2')}</p>
                                    <ul className='description-list' >
                                      <p style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text'><li> {t('help.machinepoint3')}</li> </p>
                                        <p style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text'><li>{t('help.machinepoint4')}</li></p>
                                    </ul>
                                </Box>

                                <p style={{
                                    color: subtitletext
                                }} className='home-Navi-bar-text'>{t('help.machinepoint5')}</p>

                            </Box>
                        </Box>
                        <Box className='nav-svg-sec'>
                            <img style={{
                                width: '90%',
                                // maxHeight: '500px',
                                // marginTop: '12px',
                            }} src={MachineDetails} alt="Machine Card" />

                        </Box>
                    </Box>

                    <Divider className='divider view-divider manage-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='number-sec-container '>

                        <Box className="list-container manage-list-container">

                            <ol style={{  }} className='list-numbers'>
                                <li style={{
                                    listStyle: 'none',
                                    marginLeft: '-7px'
                                }} className='number-structure  counter-c' >1.1.3 {t('help.aisleTab')}</li>
                            </ol>
                            <Box className='manage-discription level_3'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.aislepoint1')} </p>
                                <Box>
                                    <ul className='description-list' >
                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk '>{t('help.aislepoint2')}</li>
                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk '>{t('help.aislepoint3')}</li>

                                        <li style={{
                                            color: subtitletext
                                        }} className='home-Navi-bar-text disk '>{t('help.aislepoint4')}</li>
                                        <li style={{
                                            color: subtitletext 
                                        }} className='home-Navi-bar-text disk '>{t('help.aislepoint5')}</li>
                                    </ul>
                                </Box>
                            </Box>
                        </Box>
                        <Box className='aisleEdit-sec'>
                            <img className='Aisle' style={{
                                width: '90%',
                                // maxHeight: '700px',
                                // marginTop: '12px',
                                alignSelf: 'center'
                            }} src={Aisle} alt="Aisle" />
                            <Box className='editFilter'>


                                <img className='EditProduct' style={{
                                    width: '42.5%',

                                }} src={EditProduct} alt="EditProduct" />
                                <img className='Filter' style={{
                                    width: '42.5%',

                                }} src={Filter} alt="Filter" />

                            </Box>

                        </Box>
                    </Box>

                    {/* </ol> */}
                </Box>
            </Box>
            <Divider className='divider view-divider manage-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

            <Box className="manage-list-Box">
                <Box className="manage-add-machine-sec">
                    <Box className="manage-add-machine-description manage-list-container ">
                        <Box className="list-container  add-machine-sm">
                            <li className=' number-structure counter-b'>1.2 {t('help.addMachineFunctionality')}</li>
                            <Box className='manage-discription level_2'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px',marginLeft:'0px'
                                }} className='home-Navi-bar-text'>{t('help.addMachineFunctionalityText')}</p>

                            </Box>
                        </Box>
                        <Box className='number-sec-container manage-add-machine'>

                            <Box className="list-container  ">
                                <ul className='list-numbers'>
                                    <li style={{
                                        listStyle: 'none'
                                    }} className='number-structure counter-c list-wrap' >1.2.1 {t('help.generalInformationhelp')}</li>
                                </ul>
                                <Box className='manage-discription level_3' sx={{ marginLeft: '10px' }}>
                                    <p style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text'>{t('help.generalInformationhelpText')}</p>

                                </Box>
                            </Box>
                            <Box className="list-container  ">
                                <ul className='list-numbers'>
                                    <li style={{
                                        listStyle: 'none'
                                    }} className='number-structure counter-c list-wrap' >1.2.2 {t('help.machineConfiguration')}</li>
                                </ul>
                                <Box className='manage-discription level_3' sx={{ marginLeft: '10px' }}>
                                    <p style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text'>{t('help.machineConfigurationhelpText')}</p>

                                </Box>
                            </Box>
                            <Box className="list-container  ">
                                <ul className='list-numbers'>
                                    <li style={{
                                        listStyle: 'none'
                                    }} className='number-structure counter-c list-wrap' >1.2.3 {t('help.connectivityandPower')}</li>
                                </ul>
                                <Box className='manage-discription level_3' sx={{ marginLeft: '10px' }}>
                                    <p style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text'>{t('help.connectivityandPowerText')}</p>

                                </Box>
                            </Box>
                            <Box className="list-container ">
                                <ul className='list-numbers'>
                                    <li style={{
                                        listStyle: 'none'
                                    }} className='number-structure counter-c list-wrap' >1.2.4 {t('help.activationandWarranty')}</li>
                                </ul>
                                <Box className='manage-discription level_3' sx={{ marginLeft: '10px' }}>
                                    <p style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text'> {t('help.activationandWarrantyText')}</p>
                                </Box>
                            </Box>
                            <Box className="list-container ">
                                <ul className='list-numbers'>
                                    <li style={{
                                        listStyle: 'none'
                                    }} className='number-structure counter-c list-wrap' >1.2.5 {t('help.screenInformation')}</li>
                                </ul>
                                <Box className='manage-discription level_3' sx={{ marginLeft: '10px' }}>
                                    <p style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text'> {t('help.screenInformationText')}</p>
                                </Box>
                            </Box>





                        </Box>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img style={{
                            width: '85%',
                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={AddMachine} alt="Machine Card" />

                    </Box>

                </Box>


            </Box>
            <Divider className='divider view-divider ' style={{ marginTop: '50px', marginBottom: '50px' }} />

            <Box className='number-sec-container '>

                <Box className="list-container " >
                    <Box className='list-numbers' sx={{ paddingLeft: '0px', }}>
                        <p className='number-structure ' style={{marginLeft: '-12px'}}>1.3 {t('help.franchiseMachine1')} {t('help.franchiseMachine2')}</p>
                    </Box>

                    <Box className=' franchise-descriptionwidth level_2' >
                        <p style={{
                            color: subtitletext, marginTop: '10px'
                        }} className='home-Navi-bar-text'>{t('help.franchiseMachineText')}</p>

                    </Box>
                </Box>
                <Box className='nav-svg-sec'>
                    <img style={{
                        width: '90%',
                        maxHeight: '500px',
                        // marginTop: '12px',
                    }} src={Franchise} alt="Machine Card" />

                </Box>
            </Box>

            <Box className="doc-manage-Inventory">

                <p className='home-keyFeature-text doc-inventory-text ' style={{ marginTop: '50px' }}>2. {t('help.inventorytitle')}</p>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>2.1 {t('help.inventoryDisplayProduct1')}  {t('help.inventoryDisplayProduct2')}</p>
                        </Box>

                        <Box className='manage-discription'>
                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.categorySlider')}</span> {t('help.categorySliderText')}</li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.productSearch')}</span> {t('help.productSearchText')}</li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.filterButton')}</span>  {t('help.filterButtonText')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.sortOption')} </span> {t('help.sortOptionText')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.productDisplayArea')} </span> {t('help.productDisplayAreaText')}
                                </li>
                            </ul>




                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Products} alt="Machine Card" />

                    </Box>
                </Box>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container ">
                        <Box className='doc-inventory-title-sec '>

                            <p className='number-structure'>2.2 {t('help.categoriesManagementheading1')}  {t('help.categoriesManagementheading2')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.categoriesButton')}</span> {t('help.categoriesButtonText')}</p>





                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Categories} alt="Machine Card" />

                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>2.3 {t('help.addProduct')} {t('help.addProductfunctionality')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.addProductfunctionalityText')}</p>





                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white',
                            borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={AddProducts} alt="Machine Card" />

                    </Box>
                </Box>


            </Box>

            <Divider className='divider view-divider manage-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
            {/* 3 */}
            <Box className="doc-manage-Inventory">

                <p className='home-keyFeature-text doc-inventory-text ' style={{ marginTop: '50px' }}>3. {t('help.helpManageAdvertisements')}</p>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>3.1 {t('help.helpManageLiveAdvertisements1')}  {t('help.helpManageLiveAdvertisements2')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.helpManageLiveAdvertisementsText')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.helpManageLiveAdvertisementsHeadingpoint1')}</span> {t('help.helpManageLiveAdvertisementspoint1Text')}</li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.helpManageLiveAdvertisementsHeadingpoint2')}</span>   {t('help.helpManageLiveAdvertisementspoint2Text')}</li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpManageLiveAdvertisementsHeadingpoint3')}</span> {t('help.helpManageLiveAdvertisementspoint3Text')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.helpManageLiveAdvertisementsHeadingpoint4')}</span> {t('help.helpManageLiveAdvertisementspoint4Text')} </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpManageLiveAdvertisementsHeadingpoint5')} </span>   {t('help.helpManageLiveAdvertisementspoint5Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpManageLiveAdvertisementsHeadingpoint6')} </span> {t('help.helpManageLiveAdvertisementspoint6Text')}
                                </li>
                            </ul>
                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Add} alt="Machine Card" />

                    </Box>
                </Box>





                {/*  */}
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>3.2 {t('help.helpSavedAdvertisements')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.helpSavedAdvertisementsText')}</p>





                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Draft} alt="Machine Card" />

                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>3.3 {t('help.helpNewAdvertisement')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.helpNewAdvertisementpoint1Text')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc' disc> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpNewAdvertisement')}</span>{t('help.helpNewAdvertisementpoint1Text')}
                                </li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc' disc> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.helpNewAdvertisementpoint2Bold')}</span>{t('help.helpNewAdvertisementpoint2Text')}</li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc' disc> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpNewAdvertisementpoint3Bold')}</span>{t('help.helpNewAdvertisementpoint3Text')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc' disc> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.helpNewAdvertisementpoint4Bold')}</span>{t('help.helpNewAdvertisementpoint4Text')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc' disc> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpNewAdvertisementpoint5Bold')}</span>{t('help.helpNewAdvertisementpoint5Text')}</li>
                                <li style={{
                                    listStyle: "none",
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'> {t('help.helpNewAdvertisementpoint5subtext1')}
                                </li>
                                <li style={{
                                    listStyle: "none",
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'> {t('help.helpNewAdvertisementpoint5subtext2')}

                                </li>
                            </ul>



                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.helpNewAdvertisementpoint6Text')}</p>





                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white',
                            borderRadius: '5px',
                            width: '100%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={NewAddv} alt="Machine Card" />

                    </Box>
                </Box>


            </Box>
            {/* <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} /> */}
            {/* 4 */}
            <Box className="doc-manage-Inventory">

                <p className='home-keyFeature-text doc-inventory-text ' style={{ marginTop: '50px' }}>4. {t('help.CustomerManagement')}</p>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>4.1 {t('help.TypesofCustomerCount')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.TypesofCustomerCountText')}</p>
                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '100%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={CustomerTypes} alt="Machine Card" />

                    </Box>

                </Box>

                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>4.2 {t('help.TableHead')} </p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.TableText1')}</p>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.TableText2')}</p>
                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '100%',
                        }} src={CustomersTable} alt="Machine Card" />

                    </Box>

                </Box>

                <ul className='view-customer'>

                    <Box className='number-sec-container'>
                        <Box className="list-container manage-list-container">
                            <Box className='doc-inventory-title-sec'>

                                <p className='number-structure'>4.2.1 {t('help.ViewCustomerHead')} </p>
                            </Box>

                            <Box className='manage-discription level_3'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.ViewCustomerText1')}
                                </p>

                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.ViewCustomerText2')}  </p>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.ViewCustomerText3')}  </p>
                            </Box>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                backgroundColor: 'white', borderRadius: '5px',
                                width: '100%',
                            }} src={ViewCustomer} alt="Machine Card" />

                        </Box>

                    </Box>
                </ul>


            </Box>
            <Divider className='divider view-divider manage-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />


            <Box className='number-sec-container'>

                <Box className="list-container manage-list-container">
                    <Box className='doc-inventory-title-sec'>

                        <p className='number-structure'>4.3 {t('help.manageNewCustomerhead')}  </p>
                    </Box>

                    <Box className='manage-discription  level_2'>

                        <p style={{
                            color: subtitletext, marginTop: '10px'
                        }} className='home-Navi-bar-text'>{t('help.manageNewCustomerText1')} </p>

                        <ul className='new-customer-ol'>
                            <li style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.manageNewCustomerText2bold')} </span>  {t('help.manageNewCustomertext2Text')} 
                            </li>
                            <li style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.manageNewCustomerText3bold')} </span>  {t('help.manageNewCustomertext3Text')} 
                            </li>
                            <li style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.manageNewCustomerText4bold')}  </span> {t('help.manageNewCustomertext4Text')} 
                            </li>
                            <li style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.manageNewCustomerText5bold')} </span>  {t('help.manageNewCustomertext5Text')} 
                            </li>
                            <li style={{
                                listStyle: "none",
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.manageNewCustomertextSubText1')} 
                            </li>
                            <li style={{
                                listStyle: "none",
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.manageNewCustomertextSubText2')} 

                            </li>

                        </ul>
                    </Box>
                </Box>
                <Box className='nav-svg-sec' >
                    <img style={{
                        backgroundColor: 'white', borderRadius: '5px',
                        width: '100%',
                    }} src={NewCustomer} alt="Machine Card" />

                </Box>

            </Box>
            <Divider className='divider view-divider manage-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

            {/* 5 */}
            <Box className="doc-manage-Inventory">

                <p className='home-keyFeature-text doc-inventory-text' style={{ marginTop: '50px' }}>5. {t('help.ManageDiscount')}</p>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>5.1 {t('help.OfferPage')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.OfferPageText1')}</p>
                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText9bold')}</span> {t('help.OfferPagetext9Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText2bold')}</span> {t('help.OfferPagetext2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText3bold')} </span>{t('help.OfferPagetext3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText4bold')}</span> {t('help.OfferPagetext4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText5bold')}</span> {t('help.OfferPagetext5Text')}
{/*  */}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText6bold')}</span> {t('help.OfferPagetext6Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText7bold')}</span> {t('help.OfferPagetext7Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OfferPageText8bold')}</span> {t('help.OfferPagetext8Text')}
                                </li>


                            </ul>

                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={offerPage
                        } alt="Machine Card" />

                    </Box>
                </Box>

                {/*  */}
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>5.2 {t('help.DiscountOfferPop-up')} </p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.DiscountOfferPop-upText')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.DiscountOffeText2bold')} </span>{t('help.DiscountOffetext2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.DiscountOffeText3bold')}</span>{t('help.DiscountOffetext3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.DiscountOffeText4bold')} </span> {t('help.DiscountOffetext4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.DiscountOffeText5bold')} </span> {t('help.DiscountOffetext5Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.DiscountOffeText6bold')} </span>{t('help.DiscountOffetext6Text')}
                                </li>


                            </ul>



                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={
                            DiscountOffer_popup
                        } alt="Machine Card" />

                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>5.3 {t('help.newDiscountOfferPage')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.newDiscountOfferPageText')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.newDiscountOfferPageText2bold')}</span> {t('help.newDiscountOfferPagetext2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.newDiscountOfferPageText3bold')}</span> {t('help.newDiscountOfferPagetext3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.newDiscountOfferPageText4bold')}</span> {t('help.newDiscountOfferPagetext4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.newDiscountOfferPageText5bold')} </span>{t('help.newDiscountOfferPagetext5Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.newDiscountOfferPageText6bold')}</span>{t('help.newDiscountOfferPagetext6Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.newDiscountOfferPageText7bold')} </span>{t('help.newDiscountOfferPagetext7Text')}
                                </li>


                            </ul>


                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white',
                            borderRadius: '5px',
                            width: '100%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={
                            NewDiscountofferpage} alt="Machine Card" />

                    </Box>
                </Box>


            </Box>

            {/* 6 */}
            <Box className="doc-manage-Inventory">

                <p className='home-keyFeature-text doc-inventory-text' style={{ marginTop: '50px' }}>6. {t('help.Coupons')}</p>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />
                {/* 6.1 */}
                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'> {t('help.CoupontableView')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>{t('help.CouponsText')}</p>
                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText2bold')}</span>{t('help.Couponstext2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText3bold')}</span> {t('help.Couponstext3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText4bold')} </span> {t('help.Couponstext4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText5bold')} </span>{t('help.Couponstext5Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.CouponsText6bold')}</span> {t('help.Couponstext6Text')}

                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText7bold')}</span>  {t('help.Couponstext7Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText8bold')}</span>  {t('help.Couponstext8Text')}

                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText9bold')}</span> {t('help.Couponstext9Text')}
                                </li>
                               
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponsText10bold')}</span> {t('help.Couponstext10Text')}
                                </li>


                            </ul>

                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={
                            CouponTableView} alt="Machine Card" />

                    </Box>
                </Box>

                {/*  */}
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />
                {/* 6.2 */}
                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>6.2 {t('help.ViewCoupon')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.CouponstextText')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponstextText2Bold')}</span> {t('help.CouponstextText2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponstextText3Bold')} </span> {t('help.CouponstextText3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponstextText4Bold')}</span> {t('help.CouponstextText4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponstextText5Bold')}</span> {t('help.CouponstextText5Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponstextText6Bold')}  </span>{t('help.CouponstextText6Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.CouponstextText7Bold')}  </span> {t('help.CouponstextText7Text')}
                                </li>


                            </ul>



                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={
                            ViewCoupon} alt="Machine Card" />

                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />
                {/* 6.3 */}
                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>6.3 {t('help.NewCouponPopup')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.NewCouponPopupText')}</p>

                            <ul className='display-list' >

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewCouponPopupText1Bold')}</span> {t('help.NewCouponPopupText1Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewCouponPopupText2Bold')}</span>   {t('help.NewCouponPopupText2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewCouponPopupText3Bold')} </span> {t('help.NewCouponPopupText3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewCouponPopupText4Bold')} </span> {t('help.NewCouponPopupText4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewCouponPopupText5Bold')} </span> {t('help.NewCouponPopupText5Text')}
                                </li>


                            </ul>



                         





                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white',
                            borderRadius: '5px',
                            width: '100%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={

                            NewCoupons} alt="Machine Card" />

                    </Box>
                </Box>


            </Box>
            {/* 7 */}
            <Box className="doc-manage-Inventory">

                <p className='home-keyFeature-text doc-inventory-text' style={{ marginTop: '50px' }}>7. {t('help.helpUsers')}</p>

                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>
                    <Box className="user-box-display ">
                        {/*7.1 */}
                        <Box className=" list-container user-list manage-list-container">
                            <Box className='doc-inventory-title-sec'>

                                <p className='number-structure'>7.1 {t('help.UserListDisplay')}</p>
                            </Box>

                            <Box className='manage-discription level_2'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.UserListDisplayText')}</p>
                                <ul className='display-list'>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserListDisplayText1Bold')}</span> {t('help.UserListDisplayText1Text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserListDisplayText2Bold')}</span>  {t('help.UserListDisplayText2Text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserListDisplayText3Bold')} </span>  {t('help.UserListDisplayText3Text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserListDisplayText4Bold')} </span> {t('help.UserListDisplayText4Text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserListDisplayText5Bold')}</span>  {t('help.UserListDisplayText5Text')}

                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.UserListDisplayText6Bold')}</span>   {t('help.UserListDisplayText6Text')}
                                    </li>



                                </ul>

                            </Box>
                        </Box>
                        {/* 7.2 */}
                        <Box className="list-container   user-list manage-list-container" >
                            <Box className='doc-inventory-title-sec'>

                                <p className='number-structure'>7.2 {t('help.UserRolesPermissions')} </p>
                            </Box>

                            <Box className='manage-discription level_2'>

                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.UserRolesPermissionsText')}</p>

                                <ul className='display-list' >
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserRolesPermissionsText1Bold')}</span>  {t('help.UserRolesPermissionsText1Text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserRolesPermissionsText2Bold')}</span> {t('help.UserRolesPermissionsText2Text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.UserRolesPermissionsText3Bold')} </span>  {t('help.UserRolesPermissionsText3Text')}
                                    </li>
                                </ul>



                            </Box>
                        </Box>

                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={

                            UsersListRoles
                        } alt="Machine Card" />

                    </Box>
                </Box>




                <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />
                {/* 7.3 */}
                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>7.3 {t('help.NewUserForm')}<br />  </p>
                        </Box>

                        <Box className='manage-discription level_2'>

                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>  {t('help.NewUserFormText')}</p>

                            <ul className='display-list' >

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewUserFormText1Bold')}</span>  {t('help.NewUserFormText1Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewUserFormText2Bold')}</span>   {t('help.NewUserFormText2Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewUserFormText3Bold')} </span> {t('help.NewUserFormText3Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.NewUserFormText4Bold')} </span>  {t('help.NewUserFormText4Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.NewUserFormText5Bold')} </span> {t('help.NewUserFormText5Text')}
                                </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.NewUserFormText6Bold')} </span> {t('help.NewUserFormText6Text')}
                                </li>


                            </ul>


                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white',
                            borderRadius: '5px',
                            width: '100%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={

                            NewUserForm} alt="Machine Card" />

                    </Box>
                </Box>


            </Box>

        </div >
    )
}

export default Manage